<template>
  <div class="max-w-24 h-[150px] flex items-end">
    <img
      :src="imgAircraft"
      alt="Aircraft Progress animation"
      class="animation-loading w-full object-cover -mb-4"
      >
  </div>
</template>

<script setup lang="ts">
import imgAircraft from 'assets/loading-img.png'
</script>


<style scoped>
.animation-loading {
  animation: loading 4s ease-in-out infinite;
  transform-origin: center;
}

@keyframes loading {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateY(-100%) rotate(-5deg) translateX(10px);
  }
  50% {
    transform: translateY(0) rotate(0deg) translateX(-10px);
  }
  75% {
    transform: translateY(-80%) rotate(5deg) translateX(-5px);
  }
  100% {
    transform: translateY(0) rotate(0deg) translateX(0px);
  }
}

</style>
